import * as app from './app/app';
import * as appearance from './appearance/appearance';
import * as authorization from './authorization/authorization';
import * as botsCatalog from './botsCatalog/botsCatalog';
import calendar from './calendar';
import calls from './calls';
import config from './config';
import * as countriesPhoneCodes from './countriesPhoneCodes';
import * as deeplinks from './deeplinks/deeplinks';
import { downloadMessageFile } from './download/download';
import drafts from './drafts';
import e2ee from './e2ee';
import features from './features';
import feedback from './feedback';
import * as forward from './forward';
import * as globalVideoPlayer from './globalVideoPlayer/globalVideoPlayer';
import * as group from './group/group';
import market from './market';
import * as media from './media/media';
import * as messaging from './messaging/messaging';
import * as miniAudioPlayer from './miniAudioPlayer/miniAudioPlayer';
import newsfeed from './newsfeed';
import permissions from './permissions';
import * as pushNotifications from './pushNotifications/pushNotifications';
import * as reactions from './reactions/reactions';
import relationships from './relationships';
import scheduledEvents from './scheduledEvents';
import search from './search';
import * as space from './space/space';
import * as stickers from './stickers/stickers';
import streaming from './streaming';
import tenantRouter from './tenantRouter';
import thread from './thread';
import * as userSettings from './userSettings/userSettings';
import * as users from './users';
import * as workspace from './workspace/workspace';

export default {
  app,
  appearance,
  authorization,
  permissions,
  calls,
  deeplinks,
  relationships,
  messaging,
  stickers,
  group,
  search,
  userSettings,
  drafts,
  downloadMessageFile,
  streaming,
  thread,
  pushNotifications,
  globalVideoPlayer,
  media,
  users,
  space,
  newsfeed,
  feedback,
  countriesPhoneCodes,
  miniAudioPlayer,
  forward,
  market,
  reactions,
  botsCatalog,
  scheduledEvents,
  workspace,
  calendar,
  features,
  tenantRouter,
  config,
  e2ee,
};
